import { Deal } from "Types/api/Deal";
import { Person } from "Types/api/Person";
import { DealExperiments, DealState } from "Types/state";
import { API, DealResponses, DealRoutes } from "../types";
import { createAPIAction } from "./util";

export interface DealAction {
    type: API.Deal;
    route: DealRoutes;
    data: DealObject;
}

export type DealObject = GetDealPersonObject | PatchDealPersonObject;

export interface GetDealObject {
    uuid: string;
}

export interface GetDealPersonObject {
    uuid: string;
}

export interface PatchDealPersonObject {
    uuid: string;
    dealPerson: Person;
}

export interface CreateDealResponseAction {
    data: DealState;
    type: DealResponses;
}

export interface CreateDealSuccessData {
    current_data_revision: number;
    uuid: string;
    experiments?: DealExperiments;
}

export interface CreateDealSuccessAction {
    data: CreateDealSuccessData;
    type: DealResponses.CreateSuccess;
}

export function createDealSuccessAction(data: CreateDealSuccessData): CreateDealSuccessAction {
    return {
        data,
        type: DealResponses.CreateSuccess,
    };
}

export interface CreateDealErrorAction {
    type: DealResponses.CreateError;
    message: string;
}

export function createDealErrorAction(message: string): CreateDealErrorAction {
    return {
        type: DealResponses.CreateError,
        message,
    };
}

const createDealAction = (
    data: GetDealObject | GetDealPersonObject | PatchDealPersonObject,
    route: DealRoutes
): DealAction => createAPIAction(data, route)(API.Deal) as DealAction;

export const getDeal = (uuid: string) => createDealAction({ uuid }, DealRoutes.GetDeal);

export const getDealPerson = (uuid: string): DealAction => createDealAction({ uuid }, DealRoutes.GetDealPerson);

export const patchDealPerson = (uuid: string, dealPerson: Deal["person"]): DealAction =>
    createDealAction({ uuid, dealPerson }, DealRoutes.PatchDealPerson);
